import React from 'react';
import QRCode from 'react-qr-code';

interface QrCodeProps {
  value: string;
  size?: number;
  bgColor?: string;
  fgColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Reusable QR Code component using react-qr-code
 * @param value - The string value to encode in the QR code
 * @param size - The width/height of the QR code in pixels (default: 128)
 * @param bgColor - Background color (default: #fff)
 * @param fgColor - Foreground color (default: #000)
 * @param className - Optional CSS class
 * @param style - Optional inline style
 */
export const QrCode: React.FC<QrCodeProps> = ({
  value,
  size = 128,
  bgColor = '#fff',
  fgColor = '#000',
  className,
  style,
}) => {
  return (
    <QRCode
      value={value}
      size={size}
      bgColor={bgColor}
      fgColor={fgColor}
      className={className}
      style={style}
    />
  );
};
